import React from 'react';
import { ChDialog } from '../common/ChDialog/ChDialog';

interface GlobalAlertProps {
  isOpen: boolean;
  message: string;
  onClose: () => void;
}

const GlobalAlert: React.FC<GlobalAlertProps> = ({
  isOpen,
  message,
  onClose,
}) => (
  <ChDialog
    isOpen={isOpen}
    onDismiss={onClose}
    message={message}
    showLogo
    backdropDismiss={false}
    buttons={[{ text: 'OK', variant: 'primary' }]}
  />
);

export default GlobalAlert;
